export const otherInsuranceEntryEndpoints = (builder) => ({
    getOtherInsuranceEntryList: builder.query({
        query: (args = {}) => {
            const {
                pageNumber = 1,
                pageSize = 10,
                searchTerm,
                searchValue,
                sortField,
                sortOrder,
            } = args;

            const params = {
                pageNumber,
                pageSize,
            };

            if (searchTerm) params.searchTerm = searchTerm;
            if (searchValue) params.searchValue = searchValue;
            if (sortField) params.sortField = sortField;
            if (sortOrder) params.sortOrder = sortOrder;

            return {
                url: '/OtherProduct/get-other-insurance-entry-list',
                method: 'POST',
                body: params,
            };
        },
        providesTags: ['OtherInsuranceEntry'],
    }),

    getOtherInsuranceEntryById: builder.query({
        query: (id) => `/OtherProduct/get-other-insurance-entry/${id}`,
        providesTags: (result, error, id) => [{ type: 'OtherInsuranceEntry', id }],
    }),

    saveOtherInsuranceEntry: builder.mutation({
        query: (data) => ({
            url: '/OtherProduct/save-other-insurance-entry',
            method: 'POST',
            body: data,
        }),
        invalidatesTags: ['OtherInsuranceEntry'],
    }),

    deleteOtherInsuranceEntry: builder.mutation({
        query: (id) => ({
            url: `/OtherProduct/delete-other-insurance-entry/${id}`,
            method: 'DELETE',
        }),
        invalidatesTags: ['OtherInsuranceEntry'],
    }),

    bulkDeleteOtherInsuranceEntry: builder.mutation({
        query: (ids) => ({
            url: '/OtherProduct/bulk-delete-other-insurance-entry',
            method: 'DELETE',
            body: { ids },
        }),
        invalidatesTags: ['OtherInsuranceEntry'],
    }),
});
